import { render, staticRenderFns } from "./AddReportes.vue?vue&type=template&id=fbbb6de8&"
import script from "./AddReportes.vue?vue&type=script&lang=js&"
export * from "./AddReportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports